import { useEffect, useState } from 'react'

/**
 * Hook useDebounce
 * @param value - wartość do opóźnienia
 * @param delay - opóźnienie w milisekundach
 * @returns przefiltrowana (opóźniona) wartość
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    // Jeśli wartość lub delay się zmienia, resetujemy timeout
    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
